import { AiPlatform, AiPlatformInfo } from '../script';

export type ChatbotAiAccountStatus = 1 | 2;

export const CHATBOT_AI_ACCOUNT_CONFIG = {
  pageSize: 50,
  manualUrl: 'https://vpage.manual.nhanh.vn/chatbot-ai/tich-hop',
  status: {
    enabled: 1,
    disabled: 2,
  },
} as const;

export const CHATBOT_AI_ACCOUNT_PLATFORMS: ReadonlyArray<{
  value: AiPlatform;
  label: string;
}> = [
  { value: AiPlatform.OpenAI, label: AiPlatformInfo[AiPlatform.OpenAI].name },
  { value: AiPlatform.Claude, label: AiPlatformInfo[AiPlatform.Claude].name },
  { value: AiPlatform.DeepSeek, label: AiPlatformInfo[AiPlatform.DeepSeek].name },
  { value: AiPlatform.Gemini, label: AiPlatformInfo[AiPlatform.Gemini].name },
  { value: AiPlatform.Grok, label: AiPlatformInfo[AiPlatform.Grok].name },
];

export interface IChatbotAiAccount {
  id: string;
  name: string;
  platformId: AiPlatform;
  platformName: string;
  status: ChatbotAiAccountStatus;
  apiKey: string;
  createdById: string;
  createdByName?: string;
  createdAt: number;
  /** Số trợ lý đang dùng key này */
  assistantCount?: number;
}

export interface IChatbotAiAccountListParams {
  size: number;
  next?: unknown[];
}

export interface IChatbotAiAccountListData {
  items: IChatbotAiAccount[];
  next: unknown[] | false;
}

export interface IChatbotAiAccountAddParams {
  platform: AiPlatform;
  name: string;
  apiKey: string;
}

export interface IChatbotAiAccountEditParams {
  id: string;
  platform: AiPlatform;
  name: string;
  isApiKeyChanged: 0 | 1;
  apiKey?: string;
}

export interface IChatbotAiAccountIdentityParams {
  id: string;
}

export interface IChatbotAiAccountStatusParams extends IChatbotAiAccountIdentityParams {
  status: ChatbotAiAccountStatus;
}

export interface IChatbotAiAccountItemData {
  item: IChatbotAiAccount;
}
